/* eslint-disable import/no-anonymous-default-export */
export default {
  copyright: "Copyright",
  "footer.companyPrefix": "Ein Unternehmen der",
  "navBar.lang": "Sprachen",
  "layout.user.link.help": "hilfe",
  "layout.user.link.privacy": "datenschutzrichtlinie",
  "layout.user.link.terms": "nutzungsbedingungen",
  "app.home.introduce": "Hilfe",
  "app.forms.basic.title": "Grundformular",
  "app.forms.basic.description":
    "Formularseiten werden verwendet, um Benutzerinformationen zu sammeln und zu überprüfen, und Grundformulare sind in Szenarien üblich, in denen einige Informationsformate vorhanden sind.",

  areYouSureYouWantToAccept: "Sind Sie sicher, dass Sie akzeptieren möchten?",
  areYouSureYouWantToRemove: "Sind Sie sicher, dass Sie löschen möchten?",
  areYouSureYouWantToEdit: "Sind Sie sicher, dass Sie bearbeiten möchten?",
  areYouSureYouWantToClone: "Sind Sie sicher, dass Sie klonen möchten?",
  areYouSureYouWantToUndo:
    "Sind Sie sicher, dass Sie rückgängig machen möchten?",
  areYouSureYouWantToCancel: "Sind Sie sicher, dass Sie abbrechen möchten?",
  dataRecoveredSuccessfully: "Daten erfolgreich wiederhergestellt",
  "yes.IWant": "Ja, ich möchte",
  youDontHavePermission:
    "Sie haben keine Berechtigung, diese Aktion auszuführen.",
  loading: "...",
  pleaseWait: "Bitte warten",
  ok: "Ok",
  others: "Andere(s)",
  number_of_visitors: "Anzahl der Kunden",
  transfer: "Übertragen",
  hasten: "Vorziehen (Auszahlung)",
  "loading-more": "Mehr laden",
  version: "Version",
  shortVersion: "v",
  refresh: "Aktualisieren",
  search: "Suchen",
  continue: "Fortfahren",
  edit: "Bearbeiten",
  cancel: "Abbrechen",
  close: "Schließen",
  submit: "Speichern",
  status: "Status",
  reset: "Löschen",
  options: "Optionen",
  settings: "Einstellungen",
  general: "Allgemein",
  email: "E-Mail",
  cellphone: "Handy",
  telephone: "Telefon",
  create: "Erstellen",
  update: "Aktualisieren",
  delete: "Löschen",
  clone: "Klonen",
  resendEmail: "E-Mail erneut senden",
  language: "Sprache",
  all: "Alle",
  "picture.upload": "Hochladen",
  "picture.remove": "Bild entfernen",
  "picture.onDrag": "Hier ablegen",
  add: "Hinzufügen",
  balanceTotal: "Gesamtsaldo",
  balanceNotConciliationTotal: "Gesamtsaldo",
  balanceConciliationTotal: "Abgestimmtes Saldo",
  balanceNotRevenueTotal: "Erwartet",
  balanceRevenueTotal: "Realisiert",
  enabled: "Aktiv",
  disabled: "Inaktiv",
  createdAt: "Erstellt am",
  updatedAt: "Aktualisiert am",
  acceptedAt: "Akzeptiert am",
  canceledAt: "Storniert am",
  createdBy: "Erstellt von",
  updatedBy: "Aktualisiert von",
  acceptedBy: "Akzeptiert von",
  requestBy: "Angefordert von",
  canceledBy: "Storniert von",
  dateFormat: "DD/MM/YYYY",
  statement: "Kontoauszug",
  until: "bis",
  today: "Heute",
  yesterday: "Gestern",
  lastFortnight: "Letzte 15 Tage",
  nextFortnight: "Nächste 15 Tage",
  thisMonth: "Dieser Monat",
  thisYear: "1 Jahr (Ab heute)",
  goBack: "Zurück",
  calendar: "Kalender",
  lastUpdate: "Letzte Aktualisierung",

  filteredBy: "Gefiltert nach",
  filter: "Filtern",
  "filter.clean": "Filter löschen",

  "link.expired": "Abgelaufener Link",

  mail_sent: "E-Mail gesendet",
  mail_sent_to: "E-Mail gesendet an",
  "send.to.mail": "Senden per E-Mail",
  "recovery.with.success": "Erfolgreich aktualisiert!",
  "follow.procedure.sent.email":
    "Folgen Sie dem Verfahren, das per E-Mail gesendet wurde",
  "button.create": "Erstellen",
  "button.new": "Neu",
  "button.new.link": "Neuer Link",
  "button.add": "Hinzufügen",
  "button.add.and.choice": "Hinzufügen und Verwenden",
  "button.update": "Aktualisieren",
  "button.update.and.choice": "Aktualisieren und Verwenden",
  "button.select": "Auswählen",
  "button.select.recipient": "Empfänger auswählen",
  "button.send": "Senden",
  "button.share": "Teilen",
  "button.download": "Herunterladen",
  "button.download.loadingMessage":
    "Ihre Datei wird verarbeitet, wenn sie fertig ist, wird sie für Sie verfügbar sein (laden Sie die Seite nicht neu)",
  "button.view": "Anzeigen",
  "button.copy": "Kopieren",
  "button.copy.success": "Erfolgreich kopiert",
  "button.copy.link": "Link kopieren",
  "button.copy.link.success": "Link erfolgreich kopiert",

  "clean.selected": "Auswahl löschen",
  "items.selected": "Element(e) ausgewählt ",
  "yesno.true": "Ja",
  "yesno.false": "Nein",
  "yes.confirm": "Bestätigen",
  "no.cancel": "Abbrechen",
  "no.close": "Schließen",
  "yes.finish": "Beenden",
  "joinplace.welcome": "PROJEKTE verwalten, Träume bauen.",
  "joinplace.slogan": "Alle Ihre Projekte treffen sich hier",
  "joinplace.slogan.register": "Ihre Registrierung wird erstellt",
  "joinplace.welcome.register": "Träume bauen...",
  "joinplace.aboutus": "Über Joinplace",
  "joinplace.benefits": "Vorteile",
  "joinplace.visitus": "Besuchen Sie unsere Website",

  production: "Produktion",
  homologation: "Homologation",
  "normalizeRule.SOURCE": "Gleich wie Quelle",
  "normalizeRule.NUMERIC": "Nur Zahlen",
  "normalizeRule.ZERO_NUMERIC":
    "Nur Zahlen und Einbeziehung der führenden Null",
  "normalizeRule.ZERO": "Einbeziehung der führenden Null",

  "provided.conducted": "Erwartet / Realisiert",
  service: "Service",
  revenue: "Einnahmen",
  received: "Erhalten",
  late: "Verspätet",
  expenses: "Ausgaben",
  paidOut: "Bezahlt",
  predicted: "Erwartet",
  choose: "Wählen",

  "modal.close.title": "Sind Sie sicher, dass Sie gehen möchten?",
  "modal.close.description":
    "Wenn Sie gehen, verlieren Sie die geänderten Informationen ohne zu speichern.",

  nextInvoice: "Nächste Rechnung",
  "nextInvoice.message": "Die nächste Rechnung wird am Tag verfügbar sein ",

  total: "Gesamt",
  value: "Wert",
  date: "Datum",

  next: "Weiter",
  previous: "Vorherige",
  done: "Beenden",
  export: "Exportieren",
  import: "Importieren",

  empty: " ",

  "required.message": "ist erforderlich",
  "insert.message": "Bitte geben Sie das",

  I: "Ich, {name},",
  "terms.confirm.description.terms": `bestätige, dass ich die`,
  "terms.confirm.description.privacy": `und die`,
  "terms.confirm.description.joinplace": `der Joinplace-Plattform gelesen und akzeptiert habe`,

  "resend.mail.success.message": "E-Mail erfolgreich gesendet.",
  "resend.mail.error.message": "Ein Fehler trat beim Senden der E-Mail auf.",

  without_message: "Keine Informationen",

  file: "Datei",
  "upload.click-or-drag-file-text":
    "Klicken oder ziehen Sie die Datei in diesen Bereich zum Hochladen",
  "upload.click-or-drag-file-cert.hint":
    "Unterstützung für einzelnes Hochladen mit Erweiterungen .pfx oder .pcs12",
  "upload.click-or-drag-file-ofx.hint":
    "Unterstützung für einzelnes Hochladen mit Erweiterung .ofx",
  "upload.click-or-drag-file-default.hint":
    "Unterstützung für einzelnes oder mehrfaches Hochladen mit Erweiterungen .xls, .xlsx, .doc, .docx, .pdf, .png, .jpg, .txt",

  "upload.failed.message": "Hochladen fehlgeschlagen",
  "upload.success.message": "erfolgreich hochgeladen",
  "upload.removed.message": "erfolgreich entfernt",
  "upload.failed.removed.message": "Löschen fehlgeschlagen",

  "btnShowCurrency.true": "Werte ausblenden",
  "btnShowCurrency.false": "Werte anzeigen",

  "taxNumber.choose.type": "Wählen Sie den Personentyp",
  "taxNumber.validate.PP.message": "Bitte geben Sie eine gültige CPF ein.",
  "taxNumber.validate.LP.message": "Bitte geben Sie eine gültige CNPJ ein.",
  "email.invalid.message": "Bitte geben Sie eine gültige E-Mail ein.",

  "nickname.validate.character": "Muss nur Sonderzeichen . _ - enthalten",
  "nickname.validate.space": "Kann keine Leerzeichen enthalten.",
  "nickname.validate.smallLetters": "Muss nur Kleinbuchstaben enthalten.",
  "nickname.validate.maxLenght": "Muss maximal 32 Zeichen enthalten.",
  store: "Speicher",
  users: "Benutzer",
  in: "von",
  used: "verwendet",
  "page.title.projectItemList": "Geteilte Elemente",
};
